(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const motionButton = root.querySelector('.dt-motion-control');
    motionButton?.addEventListener('click', () => {
      const paused = root.classList.toggle('dt-paused');
      motionButton.setAttribute('aria-pressed', String(paused));
      motionButton.setAttribute('aria-label', paused ? 'Resume animations' : 'Pause animations');
      motionButton.title = paused ? 'Resume animations' : 'Pause animations';
    });
    const openPolicy = hash => {
      if (!['#shipping-policy', '#returns-policy'].includes(hash)) return;
      const policy = root.querySelector(hash);
      if (policy) policy.open = true;
    };
    root.querySelectorAll('a[href="#shipping-policy"],a[href="#returns-policy"]').forEach(link => {
      link.addEventListener('click', () => openPolicy(link.hash));
    });
    openPolicy(location.hash);
    if ('IntersectionObserver' in window && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const observer = new IntersectionObserver(entries => entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('dt-visible'); observer.unobserve(entry.target); }
      }), { threshold: 0.12 });
      root.classList.add('dt-motion');
      root.querySelectorAll('.dt-reveal').forEach(element => observer.observe(element));
    }
    root.querySelectorAll('[data-image]').forEach(button => button.addEventListener('click', () => {
      const img = root.querySelector('.dt-gallery-main img');
      img.src = button.dataset.src || new URL(button.dataset.image, img.src).href;
      img.alt = button.dataset.alt;
      img.parentElement.dataset.view = button.dataset.image;
      root.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
    }));
    root.querySelectorAll('[data-year]').forEach(element => element.textContent = new Date().getFullYear());
  };
  document.querySelectorAll('.dt').forEach(initialize);
  if (!window.digitrakSectionListener) {
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('.dt').forEach(initialize));
    window.digitrakSectionListener = true;
  }
})();
